import { useEffect, useRef } from 'react';
import { Outlet, useLocation, useMatches, useSearchParams } from 'react-router-dom';

import SEO from 'shared/SEO';
import { trackPage } from 'utils/analyticsUtils';
import { capitalize } from 'utils/globalUtils';

function AnalyticsLayout() {
    const location = useLocation();
    const [queryParams] = useSearchParams();
    const trackedRef = useRef('');
    const matches = useMatches();
    const routeMetadata = matches?.pop()?.handle?.meta;
    const domain = window.location.hostname;
    let routePageTitle = routeMetadata?.pageTitle;

    if (routeMetadata?.pageTitle === 'Aisle') {
        const pageTitle = matches?.pop().params.category;
        const capitalizedRoutePageTitle = pageTitle
            .split('+')
            .map((word) => capitalize(word))
            .join(' ');
        routePageTitle = capitalizedRoutePageTitle;
    }

    // track page event on URL change
    useEffect(() => {
        const locationWithQueryParams = {
            ...location,
            queryParams: Object.fromEntries(queryParams),
            isNative: !!window.isNativeApp,
            domain,
        };
        if (trackedRef.current === location.pathname) return;
        trackPage(locationWithQueryParams, routeMetadata?.pageTitle || undefined);
        trackedRef.current = location.pathname;
    }, [location, queryParams]);

    return (
        <>
            {routeMetadata?.pageTitle && <SEO title={routePageTitle} />}
            <Outlet />
        </>
    );
}

export default AnalyticsLayout;
